export default {
  baseUrl: process.env.REACT_APP_API_URL,
  FacebookAppId: process.env.REACT_APP_FB_APP_ID
};
